import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import hut from 'components/assets/img/pic/hut-flyo.svg';
import smilingbus from 'components/assets/img/pic/smiling-bus-flyo.svg';
import piggybank from 'components/assets/img/pic/piggybank-flyo.svg';
import T from 'components/common/translations/Translate';
import AppLink from 'components/common/AppLink';

class AboutProject extends Component {

  render() {
    return (
      <section className="mainpage">
        <div className="row">
          <div className="headline">
            <h2><T>content.landing.homepage.about.headline.title</T></h2>
            <p><T>content.landing.homepage.about.headline.description</T></p>
          </div>

          <ul className="profit-info">
            <li className="profit-info__item">
              <div className="profit-info__content">
                <h6><T>content.landing.homepage.about.profits.first.title</T></h6>
                <div className="profit-info__desc">
                  <p><T>content.landing.homepage.about.profits.first.description</T></p>
                </div>
                <div className="profit-info__foot">
                  <i className="fa-bulb fa-bulb--blue"></i>
                  <p><T>content.landing.homepage.about.profits.first.footer</T></p>
                  <p>
                    <T>content.landing.homepage.about.profits.first.linkFaq.preTitle</T>
                    {' '}
                    <AppLink to="routes.url.faq">
                      <T>content.landing.homepage.about.profits.first.linkFaq.title</T>
                    </AppLink>
                    <T>content.landing.homepage.about.profits.first.linkContact.separator</T>
                    <AppLink to="routes.url.contact">
                      <T>content.landing.homepage.about.profits.first.linkContact.title</T>
                    </AppLink>
                  </p>
                </div>
              </div>
              <div className="profit-info__image">
                <figure>
                  <img src={hut} alt="hut" />
                </figure>
              </div>
            </li>

            <li className="profit-info__item">
              <div className="profit-info__content">
                <h6><T>content.landing.homepage.about.profits.second.title</T></h6>
                <div className="profit-info__desc">
                  <p><T>content.landing.homepage.about.profits.second.description</T></p>
                </div>
                <div className="profit-info__foot">
                  <i className="fa-bulb fa-bulb--blue"></i>
                  <p><T>content.landing.homepage.about.profits.second.footer</T></p>
                  <p>
                    <AppLink to="routes.url.registrationStep1">
                      <T>content.landing.homepage.about.profits.second.linkTitle</T>
                    </AppLink>
                  </p>
                </div>
              </div>
              <div className="profit-info__image">
                <figure>
                  <img src={smilingbus} alt="smiling bus" />
                </figure>
              </div>
            </li>

            <li className="profit-info__item">
              <div className="profit-info__content">
                <div className="profit-info__desc">
                  <h6><T>content.landing.homepage.about.profits.third.title</T></h6>
                  <p><T>content.landing.homepage.about.profits.third.description</T></p>
                </div>
                <div className="profit-info__foot">
                  <i className="fa-bulb fa-bulb--blue"></i>
                  <p><T>content.landing.homepage.about.profits.third.footer</T></p>
                  <p>
                    <AppLink to="routes.url.prices">
                      <T>content.landing.homepage.about.profits.third.linkTitle</T>
                    </AppLink>
                  </p>
                </div>
              </div>
              <div className="profit-info__image">
                <figure>
                  <img src={piggybank} alt="piggybank" />
                </figure>
              </div>
            </li>
          </ul>
        </div>
      </section>
    );
  }
}
export default AboutProject;
